module.exports = __webpack_public_path__ + "img/logo.aedffaa2.png";